export interface HotItem {
  id: number;
  rank: number;
  tag: string;
  title: string;
  heat: string;
  trend: "up" | "down" | "flat";
  delta: string;
  category: string;
}

export interface UpdateItem {
  id: number;
  time: string;
  badge: string;
  title: string;
  summary: string;
  category: string;
  comment: number;
}

export interface NewsItem {
  id: number;
  image: string;
  category: string;
  title: string;
  excerpt: string;
  time: string;
  reads: string;
  tag?: string;
}

export interface ReviewItem {
  id: number;
  date: string;
  title: string;
  summary: string;
  image: string;
  count: number;
}

export const hotRankList: HotItem[] = [
  { id: 1, rank: 1, tag: "热", title: "年度盛典红毯造型图鉴刷屏", heat: "2863万", trend: "up", delta: "+18", category: "时尚" },
  { id: 2, rank: 2, tag: "新", title: "国民综艺新一季嘉宾阵容官宣", heat: "2410万", trend: "up", delta: "+12", category: "综艺" },
  { id: 3, rank: 3, tag: "爆", title: "暑期档票房黑马口碑逆袭", heat: "1985万", trend: "up", delta: "+35", category: "影视" },
  { id: 4, rank: 4, tag: "", title: "新生代歌手首张实体专辑开售", heat: "1520万", trend: "flat", delta: "持平", category: "音乐" },
  { id: 5, rank: 5, tag: "", title: "国际电影节华语片入围名单", heat: "1308万", trend: "up", delta: "+9", category: "影视" },
  { id: 6, rank: 6, tag: "", title: "综艺节目组否认恶意剪辑传闻", heat: "1124万", trend: "down", delta: "-6", category: "综艺" },
  { id: 7, rank: 7, tag: "", title: "顶流偶像机场私服穿搭引热议", heat: "986万", trend: "up", delta: "+14", category: "明星" },
  { id: 8, rank: 8, tag: "", title: "老牌乐队二十年巡回演唱会定档", heat: "852万", trend: "flat", color: "", delta: "持平", category: "音乐" },
  { id: 9, rank: 9, tag: "", title: "都市情感剧大结局收视破3", heat: "731万", trend: "up", delta: "+7", category: "影视" },
  { id: 10, rank: 10, tag: "", title: "品牌新春代言人官宣引发讨论", heat: "604万", trend: "down", delta: "-4", category: "品牌" },
];

export const hotTickerList: string[] = [
  "年度盛典红毯造型图鉴刷屏",
  "国民综艺新一季嘉宾阵容官宣",
  "暑期档票房黑马口碑逆袭",
  "新生代歌手首张实体专辑开售",
  "国际电影节华语片入围名单",
  "老牌乐队二十年巡回演唱会定档",
];

export const todayUpdates: UpdateItem[] = [
  { id: 1, time: "刚刚", badge: "热", title: "某热播综艺释出未播花絮片段", summary: "节目组放出两位常驻嘉宾的合作排练花絮，互动细节引发粉丝讨论。", category: "综艺", comment: 3208 },
  { id: 2, time: "18分钟前", badge: "新", title: "电影节评审团主席人选曝光", summary: "主办方确认本年度评审团阵容，其中海外导演与本土影人的组合备受期待。", category: "影视", comment: 1975 },
  { id: 3, time: "42分钟前", badge: "", title: "新生代乐队巡演官宣五城加场", summary: "因首轮售票火爆，主办方临时增加五座城市站次，并开放优先购。", category: "音乐", comment: 1480 },
  { id: 4, time: "1小时前", badge: "", title: "某品牌宣布首位品牌挚友", summary: "品牌方释出概念短片，选角与配色引起行业与网友的双重关注。", category: "品牌", comment: 966 },
  { id: 5, time: "2小时前", badge: "", title: "年代剧片方回应服化道争议", summary: "针对网友提出的细节质疑，片方发布长文说明考据与创作取舍过程。", category: "影视", comment: 2334 },
];

export const newsList: NewsItem[] = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=cinematic%20red%20carpet%20stage%20with%20warm%20golden%20spotlight%20and%20soft%20bokeh%2C%20elegant%20festival%20awards%20show%20backdrop%2C%20editorial%20glamour%20photography%2C%20film%20gala%20ambiance&width=800&height=520&seq=news-01&orientation=landscape",
    category: "综艺",
    title: "顶流综艺回归，首期嘉宾名单全解析",
    excerpt: "新一季节目在赛制与嘉宾配置上双双升级，首期看点密集，导演组更透露将增设观众直通环节。",
    time: "12分钟前",
    reads: "38.6万",
    tag: "热议",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=dark%20cinema%20theater%20with%20illuminated%20marquee%20sign%20and%20movie%20premiere%20lighting%2C%20film%20festival%20night%2C%20warm%20neon%20and%20amber%20tones%2C%20editorial%20still&width=800&height=520&seq=news-02&orientation=landscape",
    category: "影视",
    title: "暑期档黑马背后的制作手记",
    excerpt: "一部小成本影片凭口碑逆袭登顶，主创分享从剧本打磨到宣发节奏的全过程。",
    time: "34分钟前",
    reads: "25.9万",
    tag: "口碑",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=recording%20studio%20session%20with%20vintage%20microphone%20and%20warm%20desk%20lamp%20glow%2C%20music%20production%20atmosphere%2C%20editorial%20backstage%20photography%2C%20amber%20tones&width=800&height=520&seq=news-03&orientation=landscape",
    category: "音乐",
    title: "新生代歌手新专辑的幕后创作故事",
    excerpt: "从采样到母带，制作人讲述这张融合东方元素的实体专辑是如何一步步成型的。",
    time: "1小时前",
    reads: "17.2万",
    tag: "新歌",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=fashion%20studio%20editorial%20with%20warm%20backdrop%20and%20designer%20at%20work%2C%20brand%20campaign%20photography%2C%20soft%20amber%20lighting%2C%20minimal%20aesthetic&width=800&height=520&seq=news-04&orientation=landscape",
    category: "品牌",
    title: "品牌概念短片为何偏爱故事化叙事",
    excerpt: "当一支三分多钟的品牌片刷屏，我们拆解背后情感营销的底层逻辑。",
    time: "2小时前",
    reads: "12.8万",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=concert%20crowd%20silhouettes%20with%20warm%20stage%20lights%20and%20lasers%2C%20live%20music%20festival%20night%2C%20editorial%20concert%20photography%2C%20amber%20and%20coral%20tones&width=800&height=520&seq=news-05&orientation=landscape",
    category: "音乐",
    title: "万人音乐节背后的舞台工程",
    excerpt: "声光电如何在一夜之间搭建出震撼的万人现场？带你直击幕后排练。",
    time: "3小时前",
    reads: "9.4万",
    tag: "现场",
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=styling%20room%20with%20hanging%20outfits%20and%20warm%20vanity%20mirror%20lights%2C%20celebrity%20fashion%20preparation%2C%20editorial%20backstage%2C%20soft%20golden%20glow&width=800&height=520&seq=news-06&orientation=landscape",
    category: "时尚",
    title: "红毯造型的幕后时装工坊",
    excerpt: "一件件高定如何在红毯前完成尺寸与细节的最终确认，造型师亲述流程。",
    time: "4小时前",
    reads: "8.1万",
  },
];

export const reviewList: ReviewItem[] = [
  {
    id: 1,
    date: "2025-08",
    title: "八月热搜复盘：哪些话题真正出圈",
    summary: "从综艺到社会议题，我们整理了本月最具讨论度的十大热点及其传播路径。",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20spread%20with%20warm%20paper%20texture%20and%20typography%2C%20trending%20topics%20collage%2C%20amber%20and%20cream%20tones&width=800&height=520&seq=review-01&orientation=landscape",
    count: 12,
  },
  {
    id: 2,
    date: "2025-07",
    title: "暑期档观察：影院复苏进行时",
    summary: "多部影片接连定档，档期竞争激烈，我们复盘了票房与口碑的双重走向。",
    image: "https://readdy.ai/api/search-image?query=vintage%20cinema%20poster%20wall%20with%20warm%20lamplight%2C%20film%20season%20recap%2C%20editorial%20illustration%20style&width=800&height=520&seq=review-02&orientation=landscape",
    count: 9,
  },
];

export const categories: string[] = ["全部", "综艺", "影视", "音乐", "时尚", "品牌"];

export const faqList = [
  {
    q: "曝光导航每天几点更新？",
    a: "我们的内容团队会在每天上午与晚间两个时段集中推送今日更新，重要热点会以实时滚动形式第一时间补充，建议开启新料提醒订阅。",
  },
  {
    q: "热门排行的热度是如何计算的？",
    a: "排行综合了社交平台讨论量、媒体转载量、搜索趋势与用户阅读互动等多维数据，并在页面上以趋势箭头呈现相对变化。",
  },
  {
    q: "往期回顾是否支持检索？",
    a: "支持。你可以在往期回顾栏目按月份浏览已发布的月度复盘专题，也能通过站点内的分类标签快速定位到感兴趣的领域。",
  },
  {
    q: "订阅新料提醒会收费吗？",
    a: "完全免费。我们只会在有新的重点爆料或重要更新时发送提醒，你可以随时通过邮件底部的退订链接取消订阅。",
  },
];

export const brandValues = [
  { icon: "ri-focus-3-line", title: "及时", desc: "热点滚动更新，第一时间捕捉圈内动向" },
  { icon: "ri-stack-line", title: "聚合", desc: "综艺、影视、音乐、时尚一网打尽" },
  { icon: "ri-line-chart-line", title: "清晰", desc: "多维热度排行，一目了然把握趋势" },
  { icon: "ri-history-line", title: "可回溯", desc: "月度复盘沉淀，随时回看不落伍" },
];